import { render, staticRenderFns } from "./ActivityStopwatch.vue?vue&type=template&id=1680c1fd&scoped=true&"
import script from "./ActivityStopwatch.vue?vue&type=script&lang=js&"
export * from "./ActivityStopwatch.vue?vue&type=script&lang=js&"
import style0 from "./ActivityStopwatch.vue?vue&type=style&index=0&id=1680c1fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680c1fd",
  null
  
)

export default component.exports